function updateDataReduxUtil (instance, updates) {
  return {
    ...instance,
    data: {
      ...instance.data, ...updates
    }
  }
}

export default updateDataReduxUtil
